import Vue from 'vue'
export default Vue.filter('uppercase', value => value.toUpperCase())



// WEBPACK FOOTER //
// ./src/filters/string/uppercase.filter.js